import { useParams, useNavigate, Navigate } from 'react-router-dom';
import HeaderLogged from './components/header_logged';
import Container from './components/container';
import ProductionLabels from './get-labels-components/ProductionLabels';
import SeedBags from './get-labels-components/SeedBags';
import FertBags from './get-labels-components/FertBags';
import ReadyProductBoxes from './get-labels-components/ReadyProductBoxes';
import KitBoxes from './get-labels-components/KitBoxes';
import Barcodes from './get-labels-components/Barcodes';
import './GetLabelsPage.css';

// ── Tab registry — add future tabs here ───────────────────────────────────────
const TABS = [
  { slug: 'production-labels',   label: 'Production Labels',  component: ProductionLabels },
  { slug: 'seed-bags',           label: 'Seed Bags',          component: SeedBags },
  { slug: 'fertilizer-bags',     label: 'Fertilizer Bulk',    component: FertBags },
  { slug: 'ready-product-boxes', label: 'Ready Products',     component: ReadyProductBoxes },
  { slug: 'kit-boxes',           label: 'Kits',               component: KitBoxes },
  { slug: 'barcodes',            label: 'Barcodes',           component: Barcodes },
];

const GetLabelsPage = () => {
  const { tab }  = useParams();
  const navigate = useNavigate();

  if (!tab) return <Navigate to={`/get-labels/${TABS[0].slug}`} replace />;

  const activeTab = TABS.find((t) => t.slug === tab) ?? TABS[0];
  const ActiveComponent = activeTab.component;

  return (
    <div>
      <HeaderLogged />
      <Container>
        <div className="get-labels-page">

          {/* Tab bar */}
          <div className="get-labels-tabs">
            {TABS.map((t) => (
              <button
                key={t.slug}
                className={`get-labels-tab${t.slug === tab ? ' active' : ''}`}
                onClick={() => navigate(`/get-labels/${t.slug}`)}
              >
                {t.label}
              </button>
            ))}
          </div>

          {/* Active tab content */}
          <ActiveComponent />

        </div>
      </Container>
    </div>
  );
};

export default GetLabelsPage;
